var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatutoryDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400 440h64v-424h-360v56z",
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 72h352v424h-352z",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 96h160v168h-160z",
    fill: "#e0e0e2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#78b9eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m72 392h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 448h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 224h120v40h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 160h120v40h-120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 96h120v40h-120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m326.82 146.29c-29.29 12.78-51.62 13.56-62.82 12.77v-4.86a31.991 31.991 0 0 1 32-32 31.443 31.443 0 0 1 22.63 9.77 33.473 33.473 0 0 1 8.19 14.32z",
    fill: "#ff5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328 155v23.8c0 17.67-14.33 31-32 31a32.561 32.561 0 0 1 -22.63-8.87 30.329 30.329 0 0 1 -9.37-22.13v-19.74c11.2.79 33.53.01 62.82-12.77a32.693 32.693 0 0 1 1.18 8.71z",
    fill: "#ffdaaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312 226h20a20 20 0 0 1 20 20v20h-112v-20a20 20 0 0 1 20-20z",
    fill: "#006df0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312 209.77v16.23a16 16 0 0 1 -32 0v-16.23z",
    fill: "#ffdaaa"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m464 8h-360a8 8 0 0 0 -8 8v48h-48a8 8 0 0 0 -8 8v424a8 8 0 0 0 8 8h352a8 8 0 0 0 8-8v-48h56a8 8 0 0 0 8-8v-424a8 8 0 0 0 -8-8zm-72 480h-336v-408h336zm64-56h-48v-360a8 8 0 0 0 -8-8h-288v-40h344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 88h-160a8 8 0 0 0 -8 8v168a8 8 0 0 0 8 8h160a8 8 0 0 0 8-8v-168a8 8 0 0 0 -8-8zm-32 168h-96v-12a12.01 12.01 0 0 1 12-12h13.38a23.99 23.99 0 0 0 45.24 0h13.38a12.01 12.01 0 0 1 12 12zm-24-100.35v21.15c0 12.9-10.54 23-24 23s-24-10.1-24-23v-11.55c11.23-.18 27.79-2.15 48-9.6zm-47.81-6.4a23.745 23.745 0 0 1 44.09-9.29c-18.77 7.18-33.94 9.1-44.09 9.29zm31.81 65.8v8.95a8 8 0 0 1 -16 0v-8.95a43.042 43.042 0 0 0 16 0zm64 40.95h-8v-12a28.031 28.031 0 0 0 -28-28h-12v-7.8a38.381 38.381 0 0 0 16-31.4v-24.6c0-.21-.01-.42-.02-.62-.74-21.85-18.39-39.38-39.98-39.38a40.04 40.04 0 0 0 -40 40v24.6a38.381 38.381 0 0 0 16 31.4v7.8h-12a28.031 28.031 0 0 0 -28 28v12h-8v-152h144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 384h-256a8 8 0 0 0 0 16h256a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 424h136a8 8 0 0 0 0-16h-136a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 424a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 384h-24a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-8 24h-8v-8h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 440h-256a8 8 0 0 0 0 16h256a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 464h-136a8 8 0 0 0 0 16h136a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288 464h-8a8 8 0 0 0 0 16h8a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 440h-24a8 8 0 0 0 -8 8v24a8 8 0 0 0 8 8h24a8 8 0 0 0 8-8v-24a8 8 0 0 0 -8-8zm-8 24h-8v-8h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 280h-304a8 8 0 0 0 0 16h304a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 304h-304a8 8 0 0 0 0 16h304a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 328h-304a8 8 0 0 0 0 16h304a8 8 0 0 0 0-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 368h112a8 8 0 0 0 0-16h-112a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m216 368a8 8 0 0 0 0-16h-8a8 8 0 0 0 0 16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 272h120a8 8 0 0 0 8-8v-40a8 8 0 0 0 -8-8h-120a8 8 0 0 0 -8 8v40a8 8 0 0 0 8 8zm8-40h104v24h-104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 208h120a8 8 0 0 0 8-8v-40a8 8 0 0 0 -8-8h-120a8 8 0 0 0 -8 8v40a8 8 0 0 0 8 8zm8-40h104v24h-104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72 144h120a8 8 0 0 0 8-8v-40a8 8 0 0 0 -8-8h-120a8 8 0 0 0 -8 8v40a8 8 0 0 0 8 8zm8-40h104v24h-104z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatutoryDetails);
export default __webpack_public_path__ + "static/media/statutoryDetails.44332d621d27f2c27e29399e3d8c385a.svg";
export { ForwardRef as ReactComponent };